import React from "react";
import QrCode from "./qr-code";
import LaunchButton from "./launch-button";
import Logo from "./logo";
import Spinner from "./spinner";
export default ({ title, onCancel, onSwitchMethod, hasQrCode, qrCodeAsBase64, description, switchDescription, canLaunch, onLaunch, logoDimensions, hasError, }) => (React.createElement("div", { "data-ecom-frame": "" },
    React.createElement("div", { className: "frame-body" },
        React.createElement("div", { "data-ecom-page": "justify-center", className: "text-center" },
            React.createElement("section", { className: "page-section" },
                React.createElement("h1", { className: "h6" }, title),
                React.createElement("div", { "data-ecom-content": "" },
                    React.createElement("p", null, description))),
            React.createElement("section", { className: "page-section" }, hasQrCode && React.createElement(QrCode, { qrCodeAsBase64: qrCodeAsBase64 })),
            React.createElement("section", { className: "page-section" },
                React.createElement(Logo, { dimensions: logoDimensions }),
                !hasError && React.createElement(Spinner, null)),
            React.createElement("section", { className: "page-section" },
                canLaunch && React.createElement(LaunchButton, { onLaunch: onLaunch }),
                React.createElement("div", { className: "repeat-m" },
                    React.createElement("button", { "data-ecom-link": "", onClick: onSwitchMethod }, switchDescription)),
                React.createElement("div", { className: "repeat-m" },
                    React.createElement("button", { "data-ecom-link": "", onClick: onCancel }, "Avbryt")))))));
